import { flatten } from 'ramda';

export const getNestedErrors = (errors, path = []) =>
  flatten(
    Object.entries(errors).map(([key, value]) => {
      const currentPath = [...path, key];
      if (value.message) {
        return [{ fieldName: currentPath.join('.'), message: value.message }];
      }
      if (typeof value === 'object') {
        return getNestedErrors(value, currentPath);
      }
      return [];
    })
  );
